export const APP_PATHS = {
    HOME: '/',
    SEARCH: '/search',
    SEARCH_ORGS: '/search/organisations',
    ATTENDEE: '/attendee/:attendeeId',
    ORGANISATION: '/organisation/:organisationId',
    SCHEDULE: '/schedule',
    ACCOUNT: '/account',
    LOGIN: '/login',
    MESSAGES: '/messages',
    BOOKMARKS: '/bookmarks',
    MESSAGE_THREAD: '/messages/thread/:threadId'
};

// Backend URLs called by the frontend to get data
// Django has APPEND_SLASH=True
export const API_PATHS = {
    EVENT: '/api/v2/event',
    ME: '/api/v2/me',
    ATTENDEES: '/api/v2/my/attendees/',
    QUICKSEARCH: '/api/v2/my/quicksearch/', // ?q=<NAME> Minimal attendee+org view for ajax widgets
    ATTENDEE_EDIT:  '/api/v2/my/attendee/', // Base URL for Attendee Options/Get/Post
    PASSWORD_EDIT: '/api/v2/my/password/', // Password for current user
    ORGANISATION_EDIT:  '/api/v2/my/organisation/',
    ORGANISATIONS: '/api/v2/my/organisations/',
    GROUPS: '/api/v2/groups/',
    MEETINGS: '/api/v2/my/meetings/',
    MESSAGES: '/api/v2/my/messages/',
    MESSAGES_READ_BASE: '/api/v2/my/messages/read/',
    MESSAGES_LATEST: '/api/v2/my/messages/latest',
    MESSAGES_MY_POINTERS: '/api/v2/my/messages/pointers',
    MESSAGES_ROOM_INFO: '/api/v2/my/messages/room/',  // Base URL. Has room name appended
    NOTES: '/api/v2/my/notes/',
    MY_APPOINTMENTS: '/api/v2/my/appointments/', // Available to all, including anon

    SLOTS: '/api/v2/meetingslots/',
    TRACKS: '/api/v2/tracks/',
    APPOINTMENTS: '/api/v2/appointments/',  // Obsolete?
    CUSTOM_FIELDS: '/api/v2/customfields/',

    MEETING_AVAILABLE: '/api/v2/my/meetings/available',
    MEETING_PRIVATE: '/api/v2/my/meetings/private',

    SCHEDULE_PRINT_REDIRECT: '/api/v2/my/meetings/print/redirect',

    
    AUTH: '/api/v2/auth',
    LOGOUT: '/api/v2/noauth',
    /* TODO: Custom fields, meeting points/slots? */

    REGISTER: '/api/v2/register/', // <int:group_id>/
    AUTH_TOKEN: '/auth/jwt', // Request jwt from legacy sf1 rather than Django!
    AUTH_TOKEN_ADMIN: '/admin/auth/jwt',

    VIDEO_HOOK: '/api/v2/video/hook',
    VIDEOS_LIVE: '/api/v2/video/live/',
    VIDEO_ARCHIVE: '/api/v2/videoarchive/', // Staff-only

    VIDEO_ARCHIVE_BASE: '/api/v2/video/archive/',  // video/archive/<int:session_id>/start
    VIDEO_ARCHIVE_START: '/api/v2/video/archive/start',  // video/archive/<int:session_id>/start
    VIDEO_ARCHIVE_STOP: '/api/v2/video/archive/stop',  // video/archive/<int:session_id>/start
    VIDEO_ARCHIVE_APPOINTMENT:  '/api/v2/video/archive/appointment/', // video/archive/appointment/<int:appointment_id>

    VIDEO_JITSI_TOKEN: '/api/v2/token/jitsi',
    VIDEO_JITSI_BROWSERHOOK: '/api/v2/video/browserhook/jitsi',

    ADMIN_MEETINGS: '/api/v2/meetings/',

    CHAT_BASE: '/ws/v2/chat/',  // Websocket path root for [V3 | meeting | appointment | attendee] chat connections

    HTML_PROFILE: '/home/profile', // V1 Bare HTML page fragment
};

export const ADMIN_API_PATHS = {
    APPOINTMENTS: '/api/v2/admin/appointments/',
    SEARCH: '/api/v2/admin/search/',
    ATTENDEE_EDIT:  '/api/v2/manager/attendee/', // Base URL for Attendee Options/Get/Post
    ORGANISATION_EDIT:  '/api/v2/manager/organisation/', // Base URL for Organisation Options/Get/Post
    CUSTOMFIELD_EDIT: '/api/v2/manager/custom_fields/', // Base URL for CustomField editing
    ORGANISATION_CREATE: '/api/v2/manager/organisation/create/', // Base URL with '<int:group_id>/' suffix
    ATTENDEE_CREATE: '/api/v2/manager/attendee/create/', // Base URL with '<int:organisation_id>/' suffix
    MEETING_VERIFIED: '/api/v2/manager/meeting/verified/', //Base URL with '<int:meeting_id>/' suffix
    GROUP_REPORTS: '/api/v2/manager/groupreports',
    GROUP_REPORTS_BUILD: '/api/v2/manager/groupreports/build/', // Base URL with '<int:group_id>/' suffix
}

export const MEETING_STATE = {
    FAILED: -1,
    UNKNOWN: 0,
    SUCCESS: 1,
}

export const APPOINTMENT_VIDEO = {
    OFF: 0,
    MODERATOR_ONLY: 1,
    EVERYONE: 2,
}

// Synthetic state denoting whether this user can view/stream/manage a session video
export const APPOINTMENT_ATTENDEE_STATE = {
    OFF: 0,
    SUBSCRIBER: 1,
    PUBLISHER: 2,
    MODERATOR: 3,
}

// Tri-state moderator value - directly mapped to db
export const APPOINTMENT_ATTENDEE_MODERATOR = {
    BANNED: -1,
    OFF: 0,
    MODERATOR: 1,
    HOST: 2
}

// Mirrors OpenTok roles
export const VIDEO_ROLE = {
    SUBSCRIBER: 'subscriber',
    PUBLISHER: 'publisher',
    MODERATOR: 'moderator',
}

// Start & end names for the OpenTok hook replacement calls
export const VIDEO_HOOKS = {
    START: 'start',
    END: 'end'
}

export const SEARCH_BUTTON_ENABLED = 'SEARCH_BUTTON_ENABLED';
export const SETTING_MESSAGES_ON = 'USER_MESSAGES_ALLOWED';
export const SETTING_NOTE_ENABLE = 'NOTE_ENABLE';

export const FORM_ATTENDEE = {
    ALT_EMAIL: 'FORM_ATTENDEE_ALT_EMAIL',
    JOBTITLE: 'FORM_ATTENDEE_JOBTITLE',
    MOBILE: 'FORM_ATTENDEE_MOBILE',
    TITLE: 'FORM_ATTENDEE_TITLE'
};

export const FORM_ORGANISATION = {
    ADDRESS1: 'FORM_ORGANISATION_ADDRESS1',
    ADDRESS2: 'FORM_ORGANISATION_ADDRESS2',
    COUNTRY: 'FORM_ORGANISATION_COUNTRY',
    FAX: 'FORM_ORGANISATION_FAX',
    LOGO: 'FORM_ORGANISATION_LOGO',
    PHONE: 'FORM_ORGANISATION_PHONE',
    POSTCODE: 'FORM_ORGANISATION_POSTCODE',
    PROFILE: 'FORM_ORGANISATION_PROFILE',
    STATE_COUNTY: 'FORM_ORGANISATION_STATE_COUNTY',
    TOWN: 'FORM_ORGANISATION_TOWN',
    WEBSITE: 'FORM_ORGANISATION_WEBSITE'
};

// TODO: Add 'Blocked' as new priority in V2?
export const NOTE_PRIORITY = {
    HIGH: 3,
    MEDIUM: 2,
    LOW: 1,
    NONE: 0
};
export const NOTE_LABEL = {
    3: "High",
    2: "Medium",
    1: "Low",
    0: "-"
};

export const FIELD_TYPES = {
    TEXT: 'TEXT',
    TEXTAREA: 'TEXTAREA',
    URL: 'URL',
    CHECKBOX: 'CHECKBOX',
    RADIO: 'RADIO',
    SELECT: 'SELECT',
    MULTISELECT: 'MULTISELECT',
    DATE: 'DATE',
    TIME: 'TIME',
    FILE: 'FILE',
    IMAGE: 'IMAGE',
};

// List of field types that can be used as search filters/facets
// (as opposed just being used for text searches)
export const FIELD_FILTERS = [
    FIELD_TYPES.CHECKBOX,
    FIELD_TYPES.RADIO,
    FIELD_TYPES.SELECT,
    FIELD_TYPES.MULTISELECT
];


export const SEARCHABLE_FIELDS_ATTENDEE = ['full_name', 'jobtitle'];
export const SEARCHABLE_FIELDS_ORGANISATION = ['display_name', 'profile', 'country'];
export const SEARCHABLE_FIELDS =  SEARCHABLE_FIELDS_ATTENDEE.concat(SEARCHABLE_FIELDS_ORGANISATION);

export const CHAT_TYPES = { // These mirror chat/services::TYPE_*
    MESSAGE: 'chat_message',
    HISTORY: 'get_history',
    BANNED: 'banned',
    DELETE: 'delete',
    DELETE_ALL: 'deleteall',

    ERROR: 'error', // Internal websocket states
    SOCKET_CLOSED: 'socketclosed',
};
export const CHAT_SUBTYPES = {
    CLOSED: '.',
    MESSAGE: 'm',
    READY: '!',
    JOIN: '+',
    LEAVE: '-',
};

export const ITEM_TYPES = {
    TICKETED: 'ticketed', // Ticketed appointment
    BOOKABLE: 'bookable',
    PINNED: 'pinned', // appointment.in_schedule=True
    APPOINTMENT: 'appointment',
    DELETED: 'deleted', // Could be Appointment OR Meeting
    CONFIRMED: 'confirmed', // Meeting
    INBOUND: 'inbound', // Meeting
    OUTBOUND: 'outbound', // Meeting
    QUEUED: 'queued', // Compound icon of INBOUND+OUTBOUND
};

export const TRUMBOWYG_CONFIG = {
  svgPath: '/vue/img/icons.svg'
};

export const UrlImageGravatar = (path) => {
    if (path) {
        return '/media/gravatar/' + path;
    }
}

export const UrlFileRaw = (path) => {
    if (path) {
        return '/media/-/' + path;
    }
}

/** Build a standard Django compatible url based on API_PATHS / ADMIN_API_PATHS
 *
 * @param {string} base - Base path. MUST include trailing '/'
 * @param {*} param
 * @returns {string}
 */
export const buildUrlPath = (base, param) => {
    if (param) {
        return `${base}${param}/`;
    } else {
        return base;
    }
}
